export interface Category {
  name: string;
  url: string;
  icon: string;
  image: string;
}

export const categories: Category[] = [
  {
    name: 'Shoes',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    icon: 'ri-shopping-bag-3-line',
    image: 'https://readdy.ai/api/search-image?query=Premium%20white%20leather%20sneakers%20with%20golden%20accents%20displayed%20on%20minimal%20travertine%20stone%20surface%2C%20soft%20morning%20sunlight%20casting%20gentle%20shadows%2C%20clean%20editorial%20product%20photography%20with%20warm%20cream%20background%2C%20luxury%20minimalist%20aesthetic%20with%20negative%20space&width=800&height=560&seq=cat-img-shoes-001&orientation=landscape',
  },
  {
    name: 'Hoodies / Sweaters',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    icon: 'ri-t-shirt-line',
    image: 'https://readdy.ai/api/search-image?query=Oversized%20heather%20grey%20hoodie%20folded%20neatly%20on%20light%20oak%20wooden%20surface%20with%20soft%20diffused%20daylight%2C%20minimalist%20product%20photography%20with%20natural%20texture%20details%2C%20clean%20editorial%20style%20with%20warm%20beige%20backdrop%20and%20subtle%20fabric%20wrinkles&width=800&height=560&seq=cat-img-hoodies-002&orientation=landscape',
  },
  {
    name: 'T-Shirts',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    icon: 'ri-shirt-line',
    image: 'https://readdy.ai/api/search-image?query=Premium%20heavyweight%20cotton%20white%20t-shirt%20draped%20artistically%20over%20minimal%20ceramic%20surface%2C%20soft%20studio%20lighting%20from%20large%20window%2C%20clean%20fashion%20editorial%20photography%20with%20warm%20neutral%20tones%20and%20fabric%20texture%20visible&width=800&height=560&seq=cat-img-tshirt-003&orientation=landscape',
  },
  {
    name: 'Jackets',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    icon: 'ri-cloud-windy-line',
    image: 'https://readdy.ai/api/search-image?query=Sleek%20olive%20bomber%20jacket%20hanging%20artfully%20on%20scandinavian%20wooden%20hanger%20against%20clean%20eggshell%20wall%2C%20soft%20natural%20side%20lighting%2C%20editorial%20product%20photography%20with%20warm%20earth%20tones%20and%20gentle%20fabric%20folds&width=800&height=560&seq=cat-img-jackets-004&orientation=landscape',
  },
  {
    name: 'Pants / Shorts',
    url: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    icon: 'ri-scissors-line',
    image: 'https://readdy.ai/api/search-image?query=Stylish%20tailored%20beige%20linen%20trousers%20laid%20flat%20on%20minimal%20light%20marble%20surface%2C%20soft%20natural%20window%20light%20from%20above%2C%20clean%20editorial%20fashion%20photography%20with%20warm%20neutral%20palette%20and%20elegant%20draping&width=800&height=560&seq=cat-img-pants-005&orientation=landscape',
  },
  {
    name: 'Headwear',
    url: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    icon: 'ri-user-3-line',
    image: 'https://readdy.ai/api/search-image?query=Classic%20navy%20baseball%20cap%20placed%20on%20minimal%20concrete%20surface%20with%20soft%20afternoon%20sunlight%2C%20clean%20product%20photography%20with%20warm%20cream%20background%2C%20editorial%20streetwear%20aesthetic%20with%20gentle%20shadows&width=800&height=560&seq=cat-img-headwear-006&orientation=landscape',
  },
  {
    name: 'Sets',
    url: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    icon: 'ri-stack-line',
    image: 'https://readdy.ai/api/search-image?query=Matching%20cream%20color%20hoodie%20and%20jogger%20set%20folded%20together%20on%20minimal%20wooden%20bench%2C%20soft%20natural%20daylight%20from%20skylight%2C%20editorial%20lifestyle%20photography%20with%20warm%20cozy%20tones%20and%20clean%20composition&width=800&height=560&seq=cat-img-sets-007&orientation=landscape',
  },
  {
    name: 'Underwear / Underpants',
    url: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    icon: 'ri-checkbox-blank-circle-line',
    image: 'https://readdy.ai/api/search-image?query=Premium%20cotton%20underwear%20set%20neatly%20arranged%20on%20minimal%20white%20surface%20with%20soft%20diffused%20lighting%2C%20clean%20product%20photography%20with%20warm%20cream%20background%2C%20editorial%20style%20with%20delicate%20fabric%20texture&width=800&height=560&seq=cat-img-underwear-008&orientation=landscape',
  },
  {
    name: 'Jersey',
    url: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    icon: 'ri-flag-line',
    image: 'https://readdy.ai/api/search-image?query=Professional%20sports%20jersey%20in%20bold%20red%20displayed%20flat%20on%20minimal%20grey%20surface%2C%20soft%20studio%20lighting%20highlighting%20fabric%20details%2C%20clean%20product%20photography%20with%20warm%20neutral%20background%20and%20crisp%20lines&width=800&height=560&seq=cat-img-jersey-009&orientation=landscape',
  },
  {
    name: 'Accessories',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    icon: 'ri-vip-crown-line',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20arrangement%20of%20fashion%20accessories%20including%20leather%20watch%20metal%20bracelet%20and%20tortoise%20sunglasses%20on%20minimal%20travertine%20surface%2C%20soft%20morning%20light%2C%20luxury%20editorial%20photography%20with%20warm%20neutral%20tones&width=800&height=560&seq=cat-img-accessories-010&orientation=landscape',
  },
  {
    name: 'Bags',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    icon: 'ri-briefcase-line',
    image: 'https://readdy.ai/api/search-image?query=Luxury%20tan%20leather%20crossbody%20bag%20placed%20elegantly%20on%20minimal%20cream%20surface%2C%20soft%20natural%20side%20lighting%20creating%20rich%20leather%20highlights%2C%20editorial%20product%20photography%20with%20warm%20neutral%20background%20and%20refined%20composition&width=800&height=560&seq=cat-img-bags-011&orientation=landscape',
  },
  {
    name: 'Belts',
    url: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    icon: 'ri-link',
    image: 'https://readdy.ai/api/search-image?query=Handcrafted%20brown%20leather%20belt%20with%20brushed%20gold%20buckle%20curled%20on%20minimal%20white%20surface%2C%20soft%20diffused%20daylight%2C%20clean%20product%20photography%20with%20warm%20neutral%20tones%20and%20leather%20grain%20texture%20visible&width=800&height=560&seq=cat-img-belts-012&orientation=landscape',
  },
  {
    name: 'Perfumes',
    url: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    icon: 'ri-drop-line',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20glass%20perfume%20bottle%20with%20golden%20accents%20on%20minimal%20marble%20surface%20with%20soft%20candlelight%20ambiance%2C%20luxury%20product%20photography%20with%20warm%20amber%20tones%2C%20editorial%20beauty%20aesthetic%20with%20gentle%20reflections&width=800&height=560&seq=cat-img-perfumes-013&orientation=landscape',
  },
  {
    name: 'Other Stuff',
    url: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    icon: 'ri-more-line',
    image: 'https://readdy.ai/api/search-image?query=Curated%20collection%20of%20various%20fashion%20lifestyle%20items%20including%20keychain%20wallet%20socks%20and%20scarf%20on%20minimal%20wooden%20tray%2C%20soft%20natural%20lighting%2C%20editorial%20flat%20lay%20photography%20with%20warm%20neutral%20background&width=800&height=560&seq=cat-img-other-014&orientation=landscape',
  },
];

export const featuredCategories: Category[] = categories.slice(0, 6);